import { render, staticRenderFns } from "./MiniProgramRuiShiLiGouWuGlassUsers.vue?vue&type=template&id=4cbed7ac&scoped=true&"
import script from "./MiniProgramRuiShiLiGouWuGlassUsers.vue?vue&type=script&lang=js&"
export * from "./MiniProgramRuiShiLiGouWuGlassUsers.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramRuiShiLiGouWuGlassUsers.vue?vue&type=style&index=0&id=4cbed7ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbed7ac",
  null
  
)

export default component.exports